// 全站唯一的語言字串檔（目前只有 zh-TW，pilot 範圍：課程評價功能）。
// 之後要新增其他語言時，複製這個檔案的結構到 locales/<語系代碼>.js，
// 把值換成對應語言，並在 ../index.js 的 resources 裡註冊即可，不用動任何元件程式碼。
const zhTW = {
    app: {
        name: '台大資管系學會',
        fullName: '國立台灣大學資訊管理學系學會',
        englishName: 'NTU IM Student Association',
    },

    footer: {
        contact: '聯絡資訊',
        links: '相關連結',
        deptSite: '資管系官網',
        ntuSite: '台大官網',
    },

    nav: {
        home: '首頁',
        courseReviews: '課程評價',
        examArchive: '考古題',
        cheatSheets: '大抄',
        about: '關於我們',
        comingSoon: '即將推出',
        siteNavigation: '網站導覽',
        openMenu: '開啟選單',
        login: '登入',
        loginOrRegister: '登入 / 註冊',
        logout: '登出',
        joinWorkspace: '加入資管系 Google Workspace',
        feePaid: '已繳會費',
        feeUnpaid: '未繳會費',
        uploadExam: '上傳考古題',
        adminPanel: '用戶管理',
        adminExamManage: '考古題管理',
        adminCheatSheetManage: '大抄管理',
        changelog: '版本紀錄',
        adminSection: '管理員功能',
        joinWorkspaceShort: '加入 Google Workspace',
    },

    preview: {
        viewingAs: '正在以',
        viewingAsSuffix:
            '的身分檢視，全站權限與 API 回應都已切換。此模式為唯讀，無法變更任何資料。',
        stop: '停用檢視',
        stopping: '停用中…',
        someRole: '某個身分組',
        someUser: '某位成員',
    },

    guard: {
        moduleUnavailableTitle: '此功能尚未開放',
        moduleUnavailableBody: '你目前沒有使用這項功能的權限',
        comingSoonBody: '這項功能正在準備中，敬請期待',
        noPermissionTitle: '權限不足',
        noPermissionBody: '你的帳號沒有使用這項功能的權限',
        adminRequiredTitle: '需要管理員權限',
        adminRequiredBody: '此頁面僅限管理員存取',
        paymentRequiredTitle: '需要繳交系學會費',
        paymentRequiredBody: '此功能僅開放給已繳交系學會費的會員使用',
        paymentRequiredHint: '請聯繫系學會幹部或至系辦繳交會費',
        backHome: '返回首頁',
        contactUs: '聯絡我們',
        notLoggedIn: '未登入',
        welcome: '歡迎，{{name}}',
    },

    payment: {
        thisFeature: '此功能',
        title: '{{feature}}需要繳交系學會費',
        subtitle: '繳費後即可使用完整功能',
        unpaidNotice: '您的帳號 <strong>{{username}}</strong> 尚未繳交系學會費',
        loginFirst: '請先登入或註冊帳號，並繳交系學會費以使用完整功能',
        benefitsTitle: '繳費後可享有',
        benefits: [
            '參加系上活動有打折（比如真的超級好玩的系烤）',
            '學術部考古題網站的權限（卷哥卷姐必備）',
            '系學會網站完整功能',
        ],
        feeLabel: '系學會費',
        perFourYears: '/ 四年',
        reviewNotice: '繳費資格採人工審核，每日晚間統一處理；通過後即可使用完整功能。',
        contactAssociation: '聯繫系學會',
    },

    home: {
        quickAccess: '快速入口',
        quickLinks: {
            courseReviews: '查看學長姐的課程評價與選課建議',
            examArchiveTitle: '考古題庫',
            examArchive: '歷年考古題下載與參考',
            cheatSheetsTitle: '學習大抄',
            cheatSheets: '課程重點整理與筆記分享',
        },
        units: {
            reviews: '份評價',
            exams: '份考古題',
            cheatSheets: '份大抄',
        },
        banner: {
            loginTitle: '登入解鎖完整功能',
            loginBody: '下載考古題、瀏覽大抄、查看課程評價',
            unpaidTitle: '哈囉 {{name}}，尚未繳交系學會費',
            unpaidBody: '繳費後即可下載考古題與使用完整功能',
            contactToPay: '聯繫繳費',
        },
    },

    line: {
        title: 'LINE 通知',
        description: '綁定 LINE 之後，有待審核的項目會主動通知你。只有具備對應權限的人會收到。',
        notConfigured: '伺服器尚未設定 LINE 通知，請聯繫網站管理者。',
        bound: '已綁定',
        notBound: '尚未綁定',
        generateCode: '產生綁定碼',
        regenerateCode: '重新產生',
        codeReady: '請把下面這組代碼傳給系學會的 LINE 官方帳號，即可完成綁定。',
        codeExpiresAt: '有效至 {{time}}，逾期請重新產生',
        codeFailed: '產生綁定碼失敗',
        unbind: '解除綁定',
        unbound: '已解除綁定',
        unbindFailed: '解除綁定失敗',
        myBinding: '我的綁定',
        admin: {
            title: '已綁定的成員',
            description: '交接時記得解除離任幹部的綁定，否則他們畢業後仍會繼續收到通知。',
            empty: '目前沒有人綁定 LINE。',
            fetchFailed: '取得綁定名單失敗',
            colUser: '成員',
            colBoundAt: '綁定時間',
            colNotifies: '收得到的通知',
            boundAtUnknown: '未知',
            notifiesNone: '收不到任何通知',
            notify: {
                courseReviews: '課程評價',
                feedback: '意見回饋',
            },
            unbindTitle: '解除該成員的綁定',
            confirmUnbind:
                '確定要解除「{{name}}」的 LINE 綁定嗎？對方不會收到任何提示，只會從此不再收到通知。',
        },
    },

    feedback: {
        title: '意見回饋',
        category: '分類',
        categories: {
            bug: '錯誤回報',
            suggestion: '功能建議',
            other: '其他',
        },
        body: '回饋內容',
        bodyHelper: '{{count}} / {{max}} 字（至少 10 字）',
        submit: '送出',
        submitting: '送出中…',
        submitFailed: '送出回饋失敗',
        sent: '已收到您的回饋，謝謝！',
        // 刻意不寫「我們會盡快回覆您」——那會暗示送出者可被追溯，與匿名的前提矛盾
        sentHint: '由於回饋是匿名的，我們無法個別回覆，但每一則都會被看到。',
        anonymityNotice: '這則回饋是匿名的。',
        loginRequired: '請先登入才能送出回饋。',
        loginRequiredWhy: '要求登入只是為了防止灌水。',
        admin: {
            title: '回饋管理',
            description: '檢視使用者送出的匿名意見回饋',
            empty: '這個狀態下沒有回饋。',
            allStatuses: '全部',
            fetchFailed: '取得回饋清單失敗',
            updated: '回饋已更新',
            updateFailed: '更新回饋失敗',
            deleted: '回饋已刪除',
            deleteFailed: '刪除回饋失敗',
            deleteTitle: '刪除回饋',
            confirmDelete: '確定要刪除這則回饋嗎？此操作無法復原。',
            markRead: '標記為已讀',
            markResolved: '標記為已處理',
            editNote: '管理員備註',
            noteHelper: '只有管理員看得到，送出回饋的人不會知道。',
            note: '管理員備註',
            anonymityNotice:
                '回饋不記錄送出者，資料庫裡也沒有這個欄位。請勿嘗試用時間戳比對伺服器日誌來回推來源。',
            status: {
                new: '未處理',
                read: '已讀',
                resolved: '已處理',
            },
        },
    },

    announcement: {
        dialogTitle: '站上公告',
        important: '重要',
        levelInfo: '一般',
        dontRemindMe: '不要再提醒我',
        admin: {
            title: '公告管理',
            description: '發佈站上公告，使用者首次造訪時會跳出',
            create: '新增公告',
            editTitle: '編輯公告',
            empty: '目前沒有任何公告。',
            fetchFailed: '取得公告清單失敗',
            saved: '公告已儲存',
            saveFailed: '儲存公告失敗',
            deleted: '公告已刪除',
            deleteFailed: '刪除公告失敗',
            deleteTitle: '刪除公告',
            confirmDelete: '確定要刪除公告「{{title}}」嗎？此操作無法復原。',
            colTitle: '標題',
            colState: '狀態',
            colWindow: '上架 → 下架',
            colActions: '操作',
            noLimit: '不限',
            fieldTitle: '公告標題',
            fieldBody: '公告內容',
            fieldLevel: '層級',
            fieldEnabled: '啟用',
            fieldPublishAt: '上架時間',
            fieldExpireAt: '下架時間',
            bodyHelper: '純文字，換行會保留。',
            windowHelper: '兩者皆可留空，留空代表該側不限制。時間以你所在時區為準。',
            state: {
                active: '顯示中',
                disabled: '已停用',
                scheduled: '尚未上架',
                expired: '已下架',
            },
        },
    },
    about: {
        staffTab: '幹部團隊',
        contactTab: '聯絡我們',
        coreStaff: '核心幹部',
        directors: '各部部長',
        // 學年一律用民國年，與站上其他地方（考古題、課程評價）一致
        academicYearLabel: '學年度',
        yearOption: '{{year}} 學年度',
        noStaffForYear: '{{year}} 學年度的幹部名單尚未公佈。',
        officeLabel: '系辦地點',
        officeAddress: '管理學院一號館 7 樓 資訊管理學系辦公室',
    },

    auth: {
        register: '註冊',
        loginSubtitle: '使用學號或使用者名稱登入',
        loginFailed: '登入失敗，請檢查帳號密碼或網路連線',
        usernameOrStudentId: '學號或使用者名稱',
        password: '密碼',
        confirmPassword: '確認密碼',
        passwordHelper: '至少 6 個字元',
        passwordMismatch: '密碼與確認密碼不相符',
        passwordTooShort: '密碼長度至少需要 6 個字元',
        registerFailed: '註冊失敗，請稍後再試',
        registerSubtitle: '加入台大資管系學會',
        registerFeeNotice:
            '註冊後若需要使用完整功能（下載考古題、上傳大抄等），請聯繫系學會繳交會費。',
        studentId: '學號',
        studentIdExample: '例：B09705001',
        username: '使用者名稱',
        fullName: '真實姓名',
        email: '電子郵件',
        emailExample: '例：student@ntu.edu.tw',
        noAccount: '還沒有帳號？',
        registerNow: '立即註冊',
        haveAccount: '已經有帳號？',
        loginNow: '立即登入',
        forgotPassword: '忘記密碼？請聯絡',
    },

    time: {
        justNow: '剛剛',
        minutesAgo: '{{count}} 分鐘前',
        hoursAgo: '{{count}} 小時前',
        daysAgo: '{{count}} 天前',
        monthsAgo: '{{count}} 個月前',
        yearsAgo: '{{count}} 年前',
        academicTerm: '{{year}} 學年 {{semester}}',
        nthSemester: '第{{n}}學期',
    },

    validation: {
        email: '請輸入有效的電子郵件地址',
        studentId: '請輸入有效的學號格式',
        ratingRange: '評分必須介於 1-5 之間',
        pdfOnly: '只允許上傳 PDF 檔案',
        fileTooLarge: '檔案大小不能超過 10MB',
    },

    exam: {
        fetchFailed: '獲取考古題失敗',
        payToDownload: '請先繳交系學會費才能下載考古題',
        payToPreview: '請先繳交系學會費才能預覽考古題',
        stats: '共 {{count}} 份 · 累計 {{downloads}} 次下載 · {{years}} 個學年',
        searchPlaceholder: '搜尋課程名稱或教授…',
        academicYear: '{{year}} 學年',
        loadingList: '載入考古題中…',
        unknownProfessor: '未知教授',
        unknownDate: '未知日期',
        preview: '預覽',
        download: '下載',
        previewQuestions: '預覽題目',
        downloadQuestions: '下載題目',
        previewAnswers: '預覽答案',
        downloadAnswers: '下載答案',
        empty: '目前沒有考古題',
        emptyHint: '請聯繫管理員上傳考古題',
        noMatch: '沒有找到符合條件的考古題',
        noMatchHint: '請嘗試調整搜尋條件或篩選器',
        sort: {
            latest: '最新上傳',
            downloads: '下載次數',
        },
        form: {
            basicInfo: '基本資訊',
            year: '年份',
            examType: '考試類型',
            examAttempt: '考試次數',
            updateInfo: '更新資訊',
            fileManagement: '檔案管理',
            currentFiles: '當前檔案：',
            questionFile: '題目檔案：{{name}}',
            answerFile: '答案檔案：{{name}}',
            updateQuestionFile: '更新題目檔案 (PDF)',
            updateAnswerFile: '更新答案檔案 (PDF)',
            removeAnswer: '移除答案檔案',
            cancelRemoveAnswer: '取消移除答案檔案',
            updateFile: '更新檔案',
            codeAndNameRequired: '課號和課程名稱為必填',
            updateFailed: '更新失敗',
            fileUpdateFailed: '檔案更新失敗',
            pickFileOrRemove: '請選擇要更新的檔案或移除答案檔案',
            editTitle: '編輯考古題',
            semester: '學期',
        },
    },

    cheatSheet: {
        fetchFailed: '獲取大抄失敗',
        downloadFailed: '下載失敗',
        downloadFailedRetry: '下載失敗，請稍後再試',
        loginToDownload: '請先登入才能下載大抄',
        loginToPreview: '請先登入才能預覽大抄',
        loginRequired: '請先登入',
        loginRequiredBody: '登入後即可瀏覽學習大抄',
        stats: '共 {{count}} 份 · 累計 {{downloads}} 次下載 · 涵蓋 {{courses}} 門課程',
        searchPlaceholder: '搜尋標題、課程或內容…',
        courseFilter: '課程',
        popularTags: '熱門標籤',
        loadingList: '載入大抄中…',
        empty: '目前沒有大抄',
        emptyHint: '請聯繫管理員上傳大抄',
        noMatch: '沒有找到符合條件的大抄',
        noMatchHint: '請嘗試調整搜尋條件或選擇不同的標籤',
        form: {
            title: '標題',
            description: '描述',
            tags: '標籤',
            addTag: '新增標籤',
            add: '新增',
            updateFilePdf: '更新檔案 (PDF)',
            requiredFields: '課號、課程名稱和標題為必填',
            pickFile: '請選擇要上傳的檔案',
            editTitle: '編輯大抄',
        },
    },

    examUpload: {
        loginRequired: '請先登入',
        loginRequiredBody: '登入後即可上傳考古題與大抄',
        goToLogin: '前往登入',
        effectiveFrom: '114-1 起適用',
        greeting: '哈囉 {{name}}，貢獻考古題或大抄，幫助學弟妹也賺取回饋',
        viewFullRules: '查看完整規範',
        eligibleItems: '可上傳項目',
        namingPattern: '年份_學期_科目名_考試類別',
        namingExample: '（例：112-1_程式設計_期末.pdf）',
        processTitle: '上傳流程',
        viewSheetButton: '檢視已上傳清單（Google Sheet）',
        formTitle: '上傳表單',
        openInNewTab: '在新分頁開啟',
        iframeTitle: '資管考古上傳表單',
        formHint: '填寫過程可在表單內滾動；若內容過長或顯示異常，請點右上角「在新分頁開啟」。',
        notice: {
            title: '上傳前請注意',
            range: '<b>五年內</b>：含當前學期往前推（114-1 認可 110~114）。超過範圍不計入回饋。',
            answers:
                '<b>解答規範</b>：若有解答請一併附上，但<b>請勿自行撰寫答案</b>（若確定滿分例外）。',
            naming: '<b>檔案命名</b>：<code>{{pattern}}</code>（例：112-1_程式設計_期末.pdf）',
            namingWarning:
                '<b>未依命名格式者，不做計算</b>。若考題與答案分開，請分成兩個檔案上傳。',
        },
        rules: {
            title: '資管系考古上傳規範',
            s1: {
                title: '一、可上傳<red>五年內</red>之',
                exams: '・<b>考古題 / 大抄</b>：限課程（必修 / 選修 / 通識）之<redBold>期中 / 期末考</redBold>',
                calculus: '・<b>微積分</b>：僅限上傳<redBold>小考</redBold>考古題',
            },
            s2: {
                title: '二、五年內 = <red>含當前學期</red>往前推五年',
                example1Label: '例子一 ✌',
                example1:
                    '現在 114-1（認可 110~114 之考古），融融上傳 111~114 年的統計學考古共 4 份 → 通過審核，拿到回饋獎勵 <b>NT$ 250</b>',
                example2Label: '例子二 ✗',
                example2:
                    '現在 114-1，某同學上傳 1993~1996 年的資結考古共 4 份 → 因<b>超過規定時間</b>，拿不到回饋獎勵',
            },
            s3: {
                title: '三、注意事項與獎勵',
                answers:
                    '・<b>解答規範</b>：若有解答請一併附上；<red>請勿自行撰寫答案</red>（若確定滿分例外）',
                reward: '・<b>回饋獎勵</b>：每次上傳<b>4 份考古題 / 大抄</b>（不含系訂必修），待審核通過即可獲得<b> NT$ 250 </b>獎勵',
            },
            s4: {
                title: '四、上傳份數 / 回饋上限 ⚠',
                body: '為了讓每位同學都有公平繳交考古題的機會，每位同學在累積繳交滿 <redBold>32 份</redBold> 並獲得 <redBold>NT$ 2000</redBold> 獎金後，將不再繼續發放獎金。',
                exampleLabel: '例子',
                example:
                    '吱吱上傳 110~114 年共 99 份考古 + 課程評價 → 雖通過審核，但因回饋獎勵<b>上限僅能拿到 NT$ 2000</b>',
            },
            s5: {
                title: '五、上傳格式',
                examFormat: '・<b>形式</b>：原始考題電子檔及題目掃描為主，整理後以 PDF 上傳',
                examQuality: '・<b>要求</b>：清晰且可辨識文字',
                cheatSheetFormat: '・<b>形式</b>：不限手寫或打字，整理後以 PDF 上傳',
                cheatSheetQuality:
                    '・<b>要求</b>：清晰整齊且可辨識文字，有助同學複習考試（學術部會再審核）',
            },
            s6: {
                title: '六、上傳流程',
                step1Title: '1. 檢視已上傳之考古',
                step1Body:
                    '為避免重複上傳，請先點擊上方流程區的「檢視已上傳清單」按鈕，至 Google Sheet 確認',
                step2Title: '2. 填寫表單',
                step2Body:
                    '使用台大信箱（@ntu.edu.tw）填寫；檔案命名：<code>{{pattern}}</code>（例：112-1_程式設計_期末.pdf）。<red>未依命名格式者不做計算</red>；若考題與答案分開，請分成兩個檔案上傳',
                step3Title: '3. 等待審核',
                step3Body: '待審核通過 & 累積達 4 份後，學術部將於統一時間通知並發放回饋獎勵',
            },
        },
        stats: {
            range: { value: '5 年內', label: '可上傳範圍', hint: '以 114-1 為例：認可 110~114' },
            batch: { value: '4 份 / 次', label: '審核單位', hint: '累積 4 份才會發放回饋' },
            reward: { value: 'NT$ 250', label: '每次回饋', hint: '通過審核即可獲得' },
            cap: { value: '32 份 / $2000', label: '個人上限', hint: '累積達上限後不再發放' },
        },
        categories: {
            exam: {
                title: '考古題',
                desc: '限課程（必修 / 選修 / 通識）之期中 / 期末考',
                bullets: [
                    '原始考題電子檔或題目掃描為主',
                    '整理後以 PDF 上傳',
                    '清晰且可辨識文字',
                    '微積分例外：僅收小考考古題',
                ],
            },
            cheatSheet: {
                title: '大抄',
                desc: '修課重點整理，幫助同學複習',
                bullets: [
                    '不限手寫或打字',
                    '整理後以 PDF 上傳',
                    '清晰整齊且可辨識文字',
                    '由學術部審核是否錄用',
                ],
            },
        },
        steps: {
            checkList: {
                label: '檢視已上傳清單',
                desc: '為避免重複上傳，先到 Google Sheet 確認檔案是否已存在',
            },
            fillForm: {
                label: '填寫表單上傳檔案',
                desc: '使用 @ntu.edu.tw 信箱，依命名規則上傳 PDF',
            },
            awaitReview: {
                label: '等待學術部審核',
                desc: '累積達 4 份且通過審核，學術部會統一通知並發放獎勵',
            },
        },
    },

    manage: {
        deleteFailed: '刪除失敗',
        deleteIrreversible: '此操作無法復原，檔案將永久刪除。',
        adjustSearch: '請嘗試調整搜尋條件',
        noTags: '無標籤',
        examDescription: '管理系統中的所有考古題，可檢視、下載和刪除',
        examDeleted: '考古題已成功刪除',
        examInfoUpdated: '考古題資訊已更新',
        examFileUpdated: '考古題檔案已更新',
        uploadExamFirst: '請先上傳考古題',
        confirmDeleteExam: '確定要刪除「{{name}}」嗎？',
        cheatSheetDescription: '管理系統中的所有學習大抄，可檢視、下載和刪除',
        cheatSheetDeleted: '大抄已成功刪除',
        cheatSheetInfoUpdated: '大抄資訊已更新',
        cheatSheetFileUpdated: '大抄檔案已更新',
        uploadCheatSheetFirst: '請先上傳大抄',
        confirmDeleteCheatSheet: '確定要刪除「{{name}}」嗎？',
        // 兩支管理頁的表格欄位標題。原本直接寫在 JSX 裡，切成英文時整排標題仍是中文。
        columns: {
            courseInfo: '課程資訊',
            professor: '教授',
            examInfo: '考試資訊',
            fileInfo: '檔案資訊',
            uploader: '上傳者',
            uploadDate: '上傳日期',
            downloads: '下載次數',
            actions: '操作',
            title: '標題',
            description: '描述',
            tags: '標籤',
            courseName: '課程名稱',
            examType: '類型',
        },
        confirmDeleteExamTitle: '確認刪除考古題',
        confirmDeleteCheatSheetTitle: '確認刪除大抄',
    },

    admin: {
        consoleTitle: '管理員控制台',
        consoleSubtitle: '直接切到要處理的工作區，不使用滑動式分頁。',
        noAccess: '您沒有權限訪問此頁面',
        debugInfo: '調試資訊：用戶名={{username}}，角色={{role}}',
        previewSwitchFailed: '無法切換檢視身分',
        uploadCheatSheet: '上傳大抄',
        sections: {
            users: '查詢、編輯、重設密碼',
            roles: '建立身分組、調整權限與成員',
            modules: '設定各功能開放給哪些身分組',
            examManage: '搜尋、預覽、刪除',
            cheatSheetManage: '檢視內容與清理資料',
            examUpload: '新增題目與答案檔案',
            cheatSheetUpload: '建立課程重點整理',
        },
        preview: {
            selfHint: '這就是你自己的身分',
            asUser: '以「{{name}}」的身分檢視全站（唯讀）',
        },
        users: {
            fetchFailed: '無法獲取用戶資料',
            updated: '用戶資料已更新',
            deleted: '用戶 {{name}} 已刪除',
            deleteFailed: '刪除用戶失敗',
            searchPlaceholder: '搜尋帳號、姓名、Email、學號',
            paymentFilter: '繳費',
            showing: '顯示 {{shown}} / {{total}} 位用戶',
            clearFilters: '清除篩選',
            studentIdLine: '學號：{{value}}',
            registeredLine: '註冊：{{value}}',
            noEmail: '未填寫 Email',
            notProvided: '未填寫',
            paid: '已繳費',
            unpaid: '未繳費',
            resetPassword: '重設密碼',
            newPassword: '新密碼',
            enterNewPassword: '請輸入新密碼',
            passwordUpdated: '密碼已更新',
            passwordUpdateFailed: '密碼更新失敗',
            confirmChange: '確認更改',
            cannotDeleteSelf: '不能刪除自己的帳號',
            deleteUser: '刪除用戶',
            deleteThisUser: '刪除此用戶',
            editThisUser: '編輯這位用戶',
            confirmDelete: '確定要刪除用戶「{{name}}」嗎？',
            deleteIrreversible: '此操作無法復原，用戶的所有資料將被永久刪除。',
            detailTitle: '用戶詳情',
            adjustFilters: '請調整搜尋字詞或篩選條件。',
            empty: '目前沒有可顯示的用戶資料。',
            colUser: '用戶',
            colContact: '聯絡與校內資料',
            colStatus: '身份狀態',
            roleFilter: '身分組',
            noRole: '無身分組',
            changePasswordTitle: '更改密碼',
            confirmDeleteTitle: '確認刪除用戶',
        },
        upload: {
            pdfOnly: '只能上傳 PDF 檔案',
            tooLarge: '檔案大小不能超過 50MB',
            courseCodeRequired: '請輸入課號',
            courseNameRequired: '請輸入課程名稱',
            professorRequired: '請輸入教授姓名',
            yearRequired: '請選擇年份',
            questionFileRequired: '請選擇要上傳的題目 PDF 檔案',
            titleRequired: '請輸入標題',
            descriptionRequired: '請輸入描述',
            tagRequired: '請至少新增一個標籤',
            fileRequired: '請選擇要上傳的 PDF 檔案',
            failed: '上傳失敗',
            failedRetry: '上傳失敗，請稍後再試',
            uploading: '上傳中...',
            examSuccess: '考古題上傳成功！',
            cheatSheetSuccess: '大抄上傳成功！',
            courseCodeExample: '例如：IM1001',
            courseNameExample: '例如：資訊管理導論',
            professorLabel: '教授姓名',
            professorExample: '例如：王教授',
            yearRocLabel: '年份（民國）',
            questionFileLabel: '題目檔案',
            answerFileLabel: '答案檔案',
            optionalTag: '(可選)',
            pickQuestionPdf: '選擇題目 PDF',
            pickAnswerPdf: '選擇答案 PDF',
            pickPdf: '選擇 PDF 檔案',
            selected: '已選擇：{{name}}',
            answerOptionalHint: '不是每個考古題都有答案，可以不上傳',
            cheatSheetTitleLabel: '大抄標題',
            cheatSheetTitleExample: '例如：期末考重點整理',
            cheatSheetDescExample: '簡述大抄內容...',
            tagPlaceholder: '輸入標籤後按 Enter 或點擊新增',
            semesterLabel: '學期',
            examTypeLabel: '考試類型',
            examTypeMidterm: '期中考',
            examTypeFinal: '期末考',
            examTypeQuiz: '小考',
        },
        manage: {
            questionLine: '題目: {{name}}',
            answerLine: '答案: {{name}}',
        },
        roles: {
            title: '身分組管理',
            label: '身分組',
            description: '一個使用者可以擁有多個身分組，權限是所有身分組的聯集',
            create: '新增身分組',
            editTitle: '編輯身分組',
            fetchFailed: '取得身分組失敗',
            saved: '身分組已儲存',
            saveFailed: '儲存身分組失敗',
            deleted: '身分組已刪除',
            deleteFailed: '刪除身分組失敗',
            builtin: '內建',
            auto: '自動授予',
            builtinNotDeletable: '內建身分組不可刪除',
            memberCount: '成員 {{count}} 人',
            autoComputed: '（依繳費狀態自動計算）',
            allPermissions: '所有權限',
            none: '無身分組',
            noneAssignable: '沒有可指派的身分組',
            loadingOrNoAccess: '載入中或無權限讀取身分組',
            memberAutoHint: '「會員」依繳費狀態自動授予，不在此指派',
            keyLabel: '代碼',
            keyLocked: '代碼建立後不可修改',
            keyHelper: '英文字母開頭，僅可用英數字與底線',
            nameLabel: '名稱',
            descLabel: '說明',
            colorLabel: '顏色',
            priorityLabel: '排序權重',
            priorityHelper: '數字越大越前面',
            deleteWarning:
                '將刪除「{{name}}」，持有此身分組的 {{count}} 位使用者會失去對應權限。此操作無法復原。',
            permissionsLabel: '權限',
            allPermissionsLocked: '此身分組擁有所有權限，無法逐項調整',
            deleteTitle: '刪除身分組？',
        },
        modules: {
            title: '模組管理',
            description:
                '控制每個功能開放給誰。設為「限定」後，只有白名單內的身分組或使用者可以使用，管理員則一律可用（才能在正式環境先測試再公開）',
            fetchFailed: '取得模組設定失敗',
            saved: '模組設定已更新',
            saveFailed: '更新模組設定失敗',
            visibilityLabel: '開放狀態',
            allowedRoles: '可使用的身分組',
            showComingSoon: '顯示「即將推出」',
            hideCompletely: '完全隱藏',
            visibilityPublic: '公開（所有人）',
            visibilityRestricted: '限定（白名單）',
        },
    },

    changelog: {
        summary: '{{count}} 個版本 · {{from}} 起持續更新至 {{to}}',
        currentVersion: '目前版本：v{{version}}',
        latest: '最新',
    },

    error: {
        boundaryTitle: '糟糕！發生了一些問題',
        boundaryBody: '頁面載入時發生錯誤，請重新整理頁面或聯絡系統管理員。',
        reload: '重新載入',
    },

    calendar: {
        title: '台大行事曆',
        fullCalendar: '完整行事曆',
        prevMonth: '上個月',
        nextMonth: '下個月',
        yearMonth: '{{year}} 年 {{month}} 月',
        weekdays: ['日', '一', '二', '三', '四', '五', '六'],
        weekdayShort: '週{{day}}',
        legendDeadline: '重要截止',
        legendHoliday: '假期',
        legendTermEvent: '學期事件',
        upcoming: '近期行程',
        noUpcoming: '近期沒有重要事項',
    },

    feeStatus: {
        pleaseLogin: '請先登入',
        admin: '管理員身份',
        paid: '已繳交系學會費',
        unpaid: '尚未繳交系學會費',
    },

    common: {
        cancel: '取消',
        confirm: '確認',
        save: '儲存',
        delete: '刪除',
        edit: '編輯',
        close: '關閉',
        search: '搜尋',
        submit: '送出',
        loading: '載入中…',
        unknown: '未知',
        approve: '核准',
        reject: '拒絕',
        all: '全部',
        sort: '排序',
        language: '語言',
        searchPlaceholder: '搜尋...',
    },

    courseReview: {
        pageTitle: '課程評價',
        loadingReviews: '載入課程評價中…',

        viewMode: {
            feed: '所有評價',
            mine: '我的評價',
        },

        semester: {
            1: '上學期',
            2: '下學期',
            summer: '暑期',
        },

        // 學年期簡寫格式（例如 115-2、115-暑）專用的學期後綴，跟 semester 的完整名稱分開維護
        academicTermSuffix: {
            1: '1',
            2: '2',
            summer: '暑',
        },

        status: {
            pending: '待審核',
            approved: '已核准',
            rejected: '已拒絕',
        },

        metrics: {
            quality: '課程品質',
            difficulty: '難易度',
            sweetness: '給分高低',
            usefulness: '實用性',
        },

        // 評分欄位文字旁邊的小問號提示，解釋每個指標實際代表什麼
        metricHints: {
            quality: '這門課整體的教學品質好壞',
            difficulty: '這門課的上課與考試難易程度',
            sweetness: '這門課的給分甜度，越高代表給分越高、越好拿高分',
            usefulness: '這門課所學內容在實務或學習上的實用程度',
        },

        // 評價詳情彈窗裡，除了課程名稱外的分項標籤
        detailField: {
            professor: '教授',
            courseCode: '課號',
            academicTerm: '學期',
        },

        // 四個指標 1~5 分（含 0.5）文字說明，取最接近的整數對應；index 0 保留空字串不使用
        metricTexts: {
            quality: ['', '非常差', '差', '普通', '好', '非常好'],
            difficulty: ['', '非常簡單', '簡單', '普通', '困難', '非常困難'],
            sweetness: ['', '非常硬', '硬', '普通', '甜', '非常甜'],
            usefulness: ['', '沒什麼用', '不太有用', '普通', '有用', '非常有用'],
        },

        sort: {
            latestPost: '最新發表',
            ratingHighest: '評分最高',
            ratingLowest: '評分最低',
        },

        searchPlaceholder: {
            feed: '搜尋課程或教授…',
        },

        emptyState: {
            noReviewsYet: '目前還沒有任何課程評價',
            noMatchingReviews: '沒有找到符合條件的評價',
            beFirst: '成為第一個分享課程心得的人吧',
            adjustSearchOrFilter: '請嘗試調整搜尋或篩選條件',
            noReviewsMine: '你還沒有寫過課程評價',
            shareYourExperience: '分享你的修課心得，幫助其他同學選課',
            writeFirstReview: '寫下第一篇評價',
            loginToWrite: '登入後即可分享你的課程心得',
        },

        totalReviewCount: '共 {{count}} 則評價',
        writeReview: '寫評價',
        editReview: '編輯課程評價',
        newReviewTitle: '新增課程評價',
        professorFilterLabel: '教授',
        confirmDeleteReview: '確定要刪除這則評價嗎？',
        reviewedBy: '審核人：{{name}}',
        rejectReasonLabel: '拒絕原因：{{reason}}',
        clickForDetail: '點擊卡片查看完整內容',
        viewDetailTitle: '評價詳情',
        reviseAndResubmit: '編輯並重新送出',

        form: {
            courseName: '課程名稱',
            courseCode: '課號',
            professor: '授課教授',
            academicTerm: '學年期',
            allTerms: '全部',
            courseNameHelper:
                '先選學期，再輸入名稱從選單挑選，會自動帶入教授與課號；找不到也可以直接手動輸入',
            termRequiredForManualEntry:
                '學期選「全部」時請從選單挑選課程；若要手動輸入，請先指定具體學期',
            searchTruncatedHint:
                '符合的課程過多，選單只顯示一部分。請輸入更完整的課程名稱，或直接輸入授課教授姓名',
            courseContent: '課程內容',
            teachingMethod: '教學方式',
            assignmentExamFormat: '作業與考試形式',
            gradingBreakdown: '評分佔比',
            comment: '心得評論',
            notRatedYet: '尚未評分',
            anonymous: '以匿名身份發布',
            lockedFieldsHint: '課程、教授、學期資訊建立後無法修改，如有錯誤請刪除後重新新增。',
            // 字數一律插值，不要寫死（見 resources/config/constants.js 的 REVIEW_CONTENT_LIMITS）
            courseContentHelper: '{{count}} / {{max}} 字（至少 {{min}} 字，內容會自動暫存草稿）',
            requiredFieldHelper: '{{count}} / {{max}} 字（至少 {{min}} 字）',
            commentHelper:
                '{{count}} / {{max}} 字（至少 {{min}} 字，評價通過審核後才會公開顯示；內容會自動暫存草稿）',
            basicInfoRequired: '課號、課程名稱、授課教授為必填',
            ratingsIncomplete: '請完成所有評分項目',
            draftRestored: '已還原上次未完成的草稿',
            dismissDraftNotice: '知道了',
            clearDraft: '清除草稿',
            saveChanges: '儲存變更',
            submitReview: '送出評價',
            resubmit: '重新送出',
        },

        // 回饋金名額。每門課（同課號、同教授、同學年期）只有前 N 篇評價能領回饋金，
        // 目的是把誘因導向還沒人寫的課。額滿「不會」擋下投稿，只是沒有錢。
        quota: {
            label: '回饋金名額',
            chip: '{{tier}} {{used}}/{{limit}}',
            full: '已額滿',
            remaining: '尚餘 {{count}} 名',
            helper: '每則通過審核的評價可獲得 {{amount}} 元回饋金。每門課有名額上限（系上必修 3、系上選修 2、其他 1），額滿後仍然可以投稿，只是不會發放回饋金。',
            fullWarning:
                '這門課的回饋金名額（{{limit}} 名）已經額滿。你仍然可以送出評價，而且一樣會公開顯示，只是不會發放回饋金。',
            overQuota: '超出名額',
            overQuotaHint: '這門課的名額已被更早投稿的評價佔滿，本篇不發放回饋金',
            eligible: '名額內',
            tier: {
                imRequired: '系上必修',
                imElective: '系上選修',
                other: '其他',
            },
        },

        // 回饋金發放管理（總務部）
        payout: {
            title: '回饋金發放',
            description: '管理課程評價回饋金是否已發放；只有通過審核的評價才會出現在這裡',
            searchPlaceholder: '搜尋姓名、學號、課程名稱或教授...',
            // 發放狀態三態。「未處理」而不是「未發放」：後者跟「不發放」只差一個字，
            // 但意思完全相反（還沒決定 vs 已經決定不發），總務會看錯
            pending: '未處理',
            paid: '已發放',
            declined: '不發放',
            empty: '沒有符合條件的紀錄',
            recipient: '領取人',
            studentId: '學號',
            course: '課程',
            submittedAt: '投稿時間',
            status: '狀態',
            paidBy: '發放人',
            action: '操作',
            markPaid: '標記已發放',
            markDeclined: '標記不發放',
            markPending: '改回未處理',
            exportCsv: '匯出 CSV',
            anonymousTag: '匿名',
            anonymousHint: '此評價對外匿名顯示，但回饋金仍須發放給本人',
            roleTag: '總務',
            roleOn: '可管理回饋金發放',
            roleOff: '無回饋金發放權限',
            markPaidSuccess: '已標記為已發放',
            markDeclinedSuccess: '已標記為不發放',
            markPendingSuccess: '已改回未處理',
            updateFailed: '更新發放狀態失敗',
            fetchFailed: '取得發放清單失敗',
            exportFailed: '匯出失敗',
        },

        admin: {
            title: '課程評價管理',
            description:
                '撰寫課程評價有金錢回饋，所有評價須經審核通過後才會公開顯示；也可在此刪除任何評價',
            searchPlaceholder: '搜尋課程名稱、代碼或教授...',
            noMatchingReviews: '沒有符合條件的評價',
            noMatchingSearchReviews: '沒有找到符合搜尋條件的評價',
            countLabel: '共 {{count}} 則',
            submittedAt: '投稿時間：{{time}}',
            rejectDialogTitle: '拒絕此評價',
            rejectReasonInput: '拒絕原因',
            rejectReasonHelper: '會顯示給投稿者，讓對方知道需要修改的地方',
            confirmReject: '確認拒絕',
            deleteDialogTitle: '刪除這則評價？',
            deleteDialogBody: '此操作無法復原，評價內容將永久刪除。',
            confirmDelete: '確認刪除',
            approveSuccess: '評價已核准並公開顯示',
            approveFailed: '核准失敗',
            rejectSuccess: '評價已拒絕',
            rejectFailed: '拒絕失敗',
            deleteSuccess: '評價已刪除',
            deleteFailed: '刪除失敗',
        },
    },

    // 後端以 errorCode 回傳，前端統一在這裡查對應的中文訊息
    errors: {
        LINE_BAD_SIGNATURE: '簽章驗證失敗',
        LINE_NOT_CONFIGURED: 'LINE 通知尚未設定',
        LINE_BINDING_FETCH_FAILED: '取得 LINE 綁定狀態失敗',
        LINE_BINDING_CODE_FAILED: '產生綁定碼失敗',
        LINE_UNBIND_FAILED: '解除綁定失敗',
        LINE_BINDINGS_FETCH_FAILED: '取得綁定名單失敗',
        LINE_UNBIND_OTHER_FAILED: '解除該成員的綁定失敗',
        RATE_LIMITED: '操作過於頻繁，請於 {{minutes}} 分鐘後再試',
        REVIEW_RATE_LIMITED: '評價送出過於頻繁，請於 {{minutes}} 分鐘後再試',
        FEEDBACK_RATE_LIMITED: '回饋送出過於頻繁，請於 {{minutes}} 分鐘後再試',
        COURSE_NOT_IN_CATALOG: '找不到這門課程，請從搜尋結果中選擇',
        REVIEW_LIMIT_EXCEEDED: '您的評價數量已達上限',
        FEEDBACK_BODY_REQUIRED: '回饋內容為必填，請填寫 10-2000 字',
        FEEDBACK_CATEGORY_INVALID: '回饋分類無效',
        FEEDBACK_STATUS_INVALID: '回饋狀態無效',
        FEEDBACK_NOT_FOUND: '找不到這筆回饋',
        FETCH_FEEDBACK_FAILED: '取得回饋清單失敗',
        CREATE_FEEDBACK_FAILED: '送出回饋失敗',
        UPDATE_FEEDBACK_FAILED: '更新回饋失敗',
        DELETE_FEEDBACK_FAILED: '刪除回饋失敗',
        ANNOUNCEMENT_NOT_FOUND: '公告不存在',
        ANNOUNCEMENT_TITLE_REQUIRED: '公告標題為必填，且不超過 200 字',
        ANNOUNCEMENT_BODY_REQUIRED: '公告內容為必填',
        ANNOUNCEMENT_LEVEL_INVALID: '公告層級無效',
        ANNOUNCEMENT_TIME_INVALID: '上架或下架時間格式無效',
        ANNOUNCEMENT_INVALID_WINDOW: '下架時間必須晚於上架時間',
        FETCH_ANNOUNCEMENTS_FAILED: '取得公告失敗',
        CREATE_ANNOUNCEMENT_FAILED: '建立公告失敗',
        UPDATE_ANNOUNCEMENT_FAILED: '更新公告失敗',
        DELETE_ANNOUNCEMENT_FAILED: '刪除公告失敗',
        DISMISS_ANNOUNCEMENT_FAILED: '標記公告失敗',
        COURSE_CODE_REQUIRED: '課號為必填',
        COURSE_NAME_REQUIRED: '課程名稱為必填',
        PROFESSOR_REQUIRED: '授課教授為必填',
        YEAR_INVALID: '請輸入有效年份',
        SEMESTER_REQUIRED: '請選擇學期',
        QUALITY_RANGE: '課程品質須為0.5-5',
        DIFFICULTY_RANGE: '難易度須為0.5-5',
        SWEETNESS_RANGE: '給分高低須為0.5-5',
        USEFULNESS_RANGE: '實用性須為0.5-5',
        // 字數一律由後端的 params 插值帶入（見 config/reviewContent.js），
        // 不要寫死——改門檻時漏改這裡的話，錯誤訊息會跟實際規則對不上
        COURSE_CONTENT_LENGTH: '課程內容為必填，請填寫 {{min}}-{{max}} 字',
        TEACHING_METHOD_LENGTH: '教學方式為必填，請填寫 {{min}}-{{max}} 字',
        ASSIGNMENT_EXAM_FORMAT_LENGTH: '作業與考試形式為必填，請填寫 {{min}}-{{max}} 字',
        GRADING_BREAKDOWN_LENGTH: '評分佔比為必填，請填寫 {{min}}-{{max}} 字',
        COMMENT_LENGTH: '心得為必填，請填寫 {{min}}-{{max}} 字',
        TERM_NOT_REVIEWABLE: '該學期的期末考尚未結束，還不能填寫評價',
        DUPLICATE_REVIEW: '您已評價過此課程（同學期、同教授）',
        REVIEW_NOT_FOUND: '評價不存在',
        NO_PERMISSION_EDIT: '無權修改此評價',
        NO_PERMISSION_DELETE: '無權刪除此評價',
        CREATE_FAILED: '新增評價失敗',
        UPDATE_FAILED: '更新評價失敗',
        DELETE_FAILED: '刪除評價失敗',
        FETCH_FAILED: '取得評價失敗',
        FETCH_STATS_FAILED: '取得統計資料失敗',
        FETCH_LIST_FAILED: '取得評價列表失敗',
        STATUS_INVALID: '狀態須為 approved 或 rejected',
        REJECT_REASON_REQUIRED: '拒絕時請填寫拒絕原因',
        REVIEW_STATUS_UPDATE_FAILED: '審核評價失敗',
        PAYOUT_STATUS_INVALID: '發放狀態須為未處理、已發放或不發放',
        PAYOUT_REQUIRES_APPROVED: '只有已核准的評價才能標記發放',
        PAYOUT_OVER_QUOTA: '這門課的回饋金名額已滿，或有更早投稿的評價尚未審核完畢',
        PAYOUT_UPDATE_FAILED: '更新發放狀態失敗',
        FETCH_PAYOUTS_FAILED: '取得發放清單失敗',
        EXPORT_PAYOUTS_FAILED: '匯出發放清單失敗',
        GENERIC_SUBMIT_FAILED: '送出失敗，請稍後再試',

        // ---- 後端 errorCode（階段 3 補齊）----
        MODULE_NOT_AVAILABLE: '此功能尚未開放',
        ADMIN_ROLE_KEEPS_ALL: '管理員身分組必須保留所有權限',
        ANSWER_FILE_NOT_FOUND: '答案檔案不存在',
        AUTH_EXPIRED: '認證過期',
        AUTH_FAILED: '認證失敗',
        AUTH_REFRESH_INVALID: '無效的重新整理令牌',
        AUTH_REFRESH_MISSING: '未提供重新整理令牌',
        AUTH_TOKEN_EXPIRED: '認證令牌已過期',
        AUTH_TOKEN_INVALID: '無效的認證令牌',
        AUTH_TOKEN_MISSING: '未提供認證令牌',
        AUTO_ROLE_NOT_ASSIGNABLE: '「{{name}}」是自動身分組，依繳費狀態自動授予，不可手動指派',
        BUILTIN_ROLE_NOT_DELETABLE: '內建身分組不可刪除',
        CANNOT_DELETE_LAST_ADMIN: '無法刪除最後一個管理員',
        CANNOT_DELETE_SELF: '無法刪除自己的帳號',
        CANNOT_REMOVE_LAST_ADMIN: '無法移除最後一個管理員',
        CHANGE_PASSWORD_FAILED: '修改密碼失敗',
        CHEATSHEET_FILE_NOT_FOUND: '大抄檔案不存在',
        CHEATSHEET_NOT_FOUND: '大抄不存在',
        COURSE_CODE_EMPTY: '課號不能為空',
        COURSE_NAME_EMPTY: '課程名稱不能為空',
        CREATE_ROLE_FAILED: '建立身分組失敗',
        CREDENTIALS_INVALID: '帳號或密碼錯誤',
        DATABASE_ERROR: '資料庫錯誤',
        DELETE_FAILED_GENERIC: '刪除失敗',
        DELETE_ROLE_FAILED: '刪除身分組失敗',
        DELETE_USER_FAILED: '刪除使用者失敗',
        DOWNLOAD_FAILED: '下載失敗',
        DUPLICATE_DATA: '資料重複',
        EMAIL_INVALID: '請輸入有效的電子郵件',
        EMAIL_TAKEN: '此電子郵件已被使用',
        EXAM_ATTEMPT_RANGE: '考試次數須為 1-3',
        EXAM_FILE_NOT_FOUND: '考古題檔案不存在',
        EXAM_HAS_NO_ANSWER: '此考古題沒有答案檔案',
        EXAM_NOT_FOUND: '考古題不存在',
        EXAM_TYPE_REQUIRED: '請選擇考試類型',
        FEE_STATUS_INVALID: '請提供有效的繳費狀態',
        FETCH_CHEATSHEETS_FAILED: '取得大抄失敗',
        FETCH_CONTRIBUTIONS_FAILED: '取得貢獻統計失敗',
        FETCH_EXAMS_FAILED: '取得考古題失敗',
        FETCH_MEMBERS_FAILED: '取得成員失敗',
        FETCH_MODULES_FAILED: '取得模組清單失敗',
        FETCH_MODULE_SETTINGS_FAILED: '取得模組設定失敗',
        FETCH_PROFILE_FAILED: '取得個人資料失敗',
        FETCH_ROLES_FAILED: '取得身分組失敗',
        FETCH_USER_FAILED: '取得使用者資料失敗',
        FETCH_USER_LIST_FAILED: '取得使用者列表失敗',
        FIELD_ALREADY_TAKEN: '此{{field}}已被註冊',
        FILE_NOT_FOUND: '檔案不存在',
        FILE_REQUIRED: '請選擇要上傳的檔案',
        FILE_TOO_LARGE: '檔案大小超過限制',
        FILE_UPDATE_FAILED: '檔案更新失敗',
        FULL_NAME_REQUIRED: '姓名為必填',
        IDENTIFIER_REQUIRED: '請輸入學號或使用者名稱',
        INTERNAL_ERROR: '伺服器內部錯誤',
        LOGIN_FAILED: '登入失敗，請稍後再試',
        MODULE_NOT_FOUND: '模組不存在',
        NAME_REQUIRED: '名稱為必填',
        NEW_PASSWORD_REQUIRED: '請提供新密碼',
        NEW_PASSWORD_TOO_SHORT: '新密碼至少6個字元',
        NO_PERMISSION_DELETE_CHEATSHEET: '無權刪除此大抄',
        NO_PERMISSION_DELETE_EXAM: '無權刪除此考古題',
        NO_PERMISSION_EDIT_CHEATSHEET: '無權修改此大抄',
        NO_PERMISSION_EDIT_EXAM: '無權修改此考古題',
        OLD_PASSWORD_INVALID: '舊密碼錯誤',
        OPERATION_NOT_ALLOWED: '無權限執行此操作',
        PASSWORD_REQUIRED: '請輸入密碼',
        PASSWORD_TOO_SHORT: '密碼至少6個字元',
        PERMISSION_DENIED: '權限不足',
        PREVIEW_BAD_TARGET: '預覽目標格式錯誤',
        PREVIEW_ERROR: '身分預覽失敗',
        PREVIEW_FAILED: '預覽失敗，請稍後再試',
        PREVIEW_FORBIDDEN: '沒有使用身分預覽的權限',
        PREVIEW_READ_ONLY: '預覽模式為唯讀，請先停用檢視再操作',
        PREVIEW_TARGET_MISSING: '預覽目標不存在',
        QUESTION_FILE_NOT_FOUND: '題目檔案不存在',
        QUESTION_FILE_REQUIRED: '請選擇要上傳的題目檔案',
        REGISTER_FAILED: '註冊失敗，請稍後再試',
        RESOURCE_NOT_FOUND: '找不到資源',
        ROLE_KEY_FORMAT: '代碼只能用英數字與底線，且須以英文字母開頭',
        ROLE_KEY_TAKEN: '此身分組代碼已存在',
        ROLE_LIST_REQUIRED: '請提供身分組清單',
        ROLE_NOT_FOUND: '身分組不存在',
        ROLE_VALUE_INVALID: '請提供有效的角色',
        STUDENT_ID_REQUIRED: '學號為必填',
        TITLE_EMPTY: '標題不能為空',
        TITLE_REQUIRED: '標題為必填',
        TOO_MANY_FILES: '檔案數量過多',
        UNEXPECTED_FIELD: '非預期的欄位',
        UPDATE_FAILED_GENERIC: '更新失敗',
        UPDATE_FEE_STATUS_FAILED: '更新會費狀態失敗',
        UPDATE_MODULE_SETTINGS_FAILED: '更新模組設定失敗',
        UPDATE_PASSWORD_FAILED: '更新密碼失敗',
        UPDATE_PROFILE_FAILED: '更新個人資料失敗',
        UPDATE_ROLE_FAILED: '更新身分組失敗',
        UPLOAD_ERROR: '上傳錯誤：{{message}}',
        UPLOAD_FAILED: '上傳失敗',
        USERNAME_TOO_SHORT: '使用者名稱至少3個字元',
        USER_NOT_FOUND: '找不到用戶',
        VALIDATION_FAILED: '資料驗證失敗',
        NETWORK_FAILED: '網路連線失敗，請檢查您的網路連線',
        REQUEST_TIMEOUT: '請求超時，請檢查網路連線後重試',
        PAYMENT_REQUIRED: '此功能需要繳交系學會費',
    },
};

export default zhTW;
